<template>
    <!--suppress HtmlFormInputWithoutLabel -->
    <input type="text"
           v-model="value"
           placeholder="Numéro français ou +XX indicatif">
</template>

<script type="text/ecmascript-6">
    import {normalizePhoneNumber, validatePhoneNumber} from './phone-utils';

    export default {
        props: {
            'phoneNumber': {
                'default': '',
                twoWay: true
            },
            valid: {
                'default': false,
                twoWay: true
            }
        },
        data() {
            return {
                value: '',
                required: false
            };
        },
        computed: {
            cleanValue() {
                return normalizePhoneNumber(this.value);
            },
            isValid() {
                return !!(!this.value || this.phoneNumber);
            },
            hasRequiredAttr() {
                return this.required || !this.isValid;
            }
        },
        watch: {
            isValid(v) {
                if (!v) {
                    console.log('setting invalid');
                    this.$el.setCustomValidity('Ceci ne ressemble pas à un numéro de téléphone');
                } else {
                    console.log('setting valid');
                    this.$el.setCustomValidity('');
                }

                this.valid = v;
            },
            cleanValue() {
                if (validatePhoneNumber(this.cleanValue)) {
                    this.phoneNumber = this.cleanValue;
                } else {
                    this.phoneNumber = '';
                }
            },
            hasRequiredAttr(r) {
                if (r) {
                    this.$el.setAttribute('required', '');
                } else {
                    this.$el.removeAttribute('required');
                }
            }
        },
        ready() {
            if (this.phoneNumber) {
                this.value = this.$options.filters.phone(this.phoneNumber);
            }
            this.valid = this.isValid;
            this.required = this.$el.hasAttribute('required');
        }
    };
</script>



// WEBPACK FOOTER //
// InputPhone.vue?4aff6904